import { Helmet } from 'react-helmet';
import React, { useState, useRef, useEffect } from 'react';
// import { Spreadsheet, Worksheet } from '@jspreadsheet/react';
import { theme } from 'utils/style/theme';
import jspreadsheet from 'jspreadsheet';
// import render from '@jspreadsheet/render';

import '/node_modules/jspreadsheet/dist/jspreadsheet.css';
import '/node_modules/jsuites/dist/jsuites.css';

import {
  SetScriptStandard,
  checkScriptValidation,
  fetchScriptData,
  sheetColumns,
  sheetLicense,
} from './ScriptHelper';
import { useParams, useSearchParams } from 'react-router-dom';
import { scriptAPI } from 'apis/story/scriptAPI';
import ScriptLayout from 'components/layout/ScriptLayout';
import styled from 'styled-components';
import RegisterButton from 'components/button/RegisterButton';
import { useTranslation } from 'react-i18next';
import ExcelImport from './ExcelImport';
import { utils, writeFile } from 'xlsx';
import dayjs from 'dayjs';

import { handleMessage } from 'utils/helper/message';

import { useHotkeys } from 'react-hotkeys-hook';
import { Image, message } from 'antd';
import ValidationCard from './ValidationCard';

let prevCell = null;
let prevCellBackColor = null;

const ScriptSheet = () => {
  // state 모음
  const [refresh, setRefresh] = useState(false);
  const [sideRightWidth, setRightSideWidth] = useState('0px'); // 사이드 헬퍼 width.
  const [sideLeftWidth, setLeftSideWidth] = useState('0px'); // 사이드 헬퍼 width.
  const [importedExcel, setImportedExcel] = useState(null);
  const [selectedColState, setSelectedColState] = useState(null);
  const [selectedRowState, setSelectedRowState] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // 로딩중

  const [validationShow, setValidationShow] = useState(false); // 유효성 검사 구역 보여주기
  const [validationData, setValidationData] = useState(); // 유효성 검사에 걸린 데이터 배열

  // * 기준정보성 DropDown data
  const [templateButtons, setTemplateButtons] = useState(null); // 템플릿 리스트

  const { t } = useTranslation(); // 다국어 지원
  const jssRef = useRef(null); // jspreadsheet
  const windowHeight = useRef(window.innerHeight);

  // 파라매터들.
  const { project_id, episode_id } = useParams();
  const [searchParam] = useSearchParams();

  // 언어, 프로젝트 타이틀, 에피소드 타이틀
  const lang = searchParam.get('lang');
  const projectTitle = searchParam.get('title');
  const episodeTitle = searchParam.get('episode');

  // *스크립트 기준정보
  const scriptStandard = useRef({
    inEffect: null,
    outEffect: null,
    speaker: null,
    motion: null,
    emoticon: null,
    minicut: null, // 미니컷
    background: null, // 배경 이미지
    illust: null, // 이미지 일러스트
  }); //

  jspreadsheet.setLicense(sheetLicense);

  // * 서버에서 스크립트 데이터 가져오기
  const handleFetchData = async () => {
    console.log(`>>> handle fetch data ${project_id}/${episode_id}/${lang}`);

    const scripts = await fetchScriptData(project_id, episode_id, lang);

    if (!scripts) {
      handleMessage(`No scripts info here`, 'error');
      return;
    }

    console.log(`fetch result : `, scripts);
    if (scripts && scripts.length > 0)
      jssRef.current.jspreadsheet[0].setData(scripts);
    // jssRef.current.jspreadsheet[0].setStyle({
    //   A1: 'font-weight:bold;',
    //   D1: 'font-size:1rem',
    //   D2: 'font-size:12px',
    //   D3: 'font-size:14px',
    //   D4: 'font-size:16px',
    // });

    fetchDropDownData();
  }; // ? END handle Fecth Data

  // * 기준정보 드롭다운 데이터 가져오기
  const fetchDropDownData = async () => {
    console.log(`>>> fetchDropDownData`);

    const templateList = await scriptAPI.getTemplateList(lang);
    const inEffectList = await scriptAPI.getInEffectList(lang); // 등장 효과
    const outEffectList = await scriptAPI.getOutEffectList(lang); // 퇴장 효과
    const resourceInfo = await scriptAPI.getScriptResourceLists(project_id);

    const speakerList = resourceInfo.speakers;
    const motionList = resourceInfo.motions;
    const emoticonList = resourceInfo.emoticons;
    const images = resourceInfo.images;

    // console.log(templateList);
    scriptStandard.current.inEffect = inEffectList;
    scriptStandard.current.outEffect = outEffectList;
    scriptStandard.current.speaker = speakerList;
    scriptStandard.current.motion = motionList;
    scriptStandard.current.emoticon = emoticonList;
    scriptStandard.current.minicut = images.filter(
      (item) => item.image_type === 'minicut',
    );
    scriptStandard.current.background = images.filter(
      (item) => item.image_type === 'bg',
    );
    scriptStandard.current.illust = images.filter(
      (item) => item.image_type === 'illust',
    );

    setTemplateButtons(templateList);

    SetScriptStandard(scriptStandard);

    console.log(scriptStandard);
  }; // ? end fetchDropDownData

  // * 사이드 영역 버튼 누르기!
  const handleClickSideButton = (e) => {
    jssRef.current.jspreadsheet[0].setValueFromCoords(
      selectedColState,
      selectedRowState,
      e.target.name,
      true,
    );
  };

  // * 모션 영역
  const divMotionSide = () => {
    if (!scriptStandard.current.motion) return '';

    // 선택된 행의 speaker 컬럼의 모션을 찾아줘야한다.
    const speaker = jssRef.current.jspreadsheet[0].getValueFromCoords(
      2,
      selectedRowState,
    );

    console.log(
      `divMotionSide : ${speaker}/${selectedColState}/${selectedRowState}`,
    );

    // if (!speaker || speaker == '') {
    //   return '';
    // }

    const validMotion = scriptStandard.current.motion.filter(
      (item) => item.model_name == speaker,
    );

    return (
      <ContentButtonContainer>
        <h6>캐릭터 모션 정보</h6>
        {validMotion &&
          validMotion.map((v, i) => (
            <button
              key={i}
              value={v.motion_name}
              name={v.motion_name}
              onClick={handleClickSideButton}
            >
              {v.motion_name}
            </button>
          ))}
        {validMotion.length == 0 ? <h4>** 등록된 모션이 없습니다</h4> : ''}
      </ContentButtonContainer>
    );
  };

  // * 템플릿 배경 + 데이터 영역
  const divBackgroundImageSide = () => {
    if (!scriptStandard.current.background) return '';
    return (
      <ContentButtonContainer>
        <h6>배경 이미지</h6>
        {scriptStandard.current.background.map((v, i) => (
          <div style={{ marginBottom: '10px' }}>
            <Image
              src={'https://d3h4v3hjyy5iri.cloudfront.net/' + v.image_key}
              style={{
                width: '70px',
                height: '70px',
                margin: 'auto',
              }}
            />
            <button
              key={i}
              value={v.image_name}
              name={v.image_name}
              onClick={handleClickSideButton}
            >
              {v.image_name}
            </button>
          </div>
        ))}
        {scriptStandard.current.background.length === 0 ? (
          <h4>** 등록된 배경이 없습니다</h4>
        ) : (
          ''
        )}
      </ContentButtonContainer>
    );
  };

  // * 이모티콘 영역
  const divEmoticonSide = () => {
    if (!scriptStandard.current.emoticon) return '';

    // 선택된 행의 speaker 컬럼의 모션을 찾아줘야한다.
    const speaker = jssRef.current.jspreadsheet[0].getValueFromCoords(
      2,
      selectedRowState,
    );

    console.log(
      `divEmoticonSide : ${speaker}/${selectedColState}/${selectedRowState}`,
    );

    const validList = scriptStandard.current.emoticon.filter(
      (item) => item.speaker == speaker,
    );

    return (
      <ContentButtonContainer>
        <h6>이모티콘 정보</h6>
        {validList &&
          validList.map((v, i) => (
            <button
              key={i}
              value={v.emoticon}
              name={v.emoticon}
              onClick={handleClickSideButton}
            >
              {v.emoticon}
            </button>
          ))}
        {validList.length == 0 ? <h4>** 등록된 이모티콘이 없습니다</h4> : ''}
      </ContentButtonContainer>
    );
  };

  const divInEffectSide = () => {
    if (!scriptStandard.current.inEffect) return '';

    return (
      <ContentButtonContainer>
        <h6>등장 연출 리스트</h6>
        {scriptStandard.current.inEffect.map((v, i) => (
          <button
            key={i}
            value={v.code}
            name={v.code_name}
            onClick={handleClickSideButton}
          >
            {v.code_name}
          </button>
        ))}
      </ContentButtonContainer>
    );
  };
  const divOutEffectSide = () => {
    if (!scriptStandard.current.outEffect) return '';

    return (
      <ContentButtonContainer>
        <h6>등장 연출 리스트</h6>
        {scriptStandard.current.outEffect.map((v, i) => (
          <button
            key={i}
            value={v.code}
            name={v.code_name}
            onClick={handleClickSideButton}
          >
            {v.code_name}
          </button>
        ))}
      </ContentButtonContainer>
    );
  };

  // * 화자 사이드 영역
  const divSpeakerSide = () => {
    if (!scriptStandard.current.speaker) return '';

    // 프로필과 네임태그가 나뉜다.
    const profileSpeaker = scriptStandard.current.speaker.filter(
      (item) => item.data_source == 'profile',
    );
    const tagSpeaker = scriptStandard.current.speaker.filter(
      (item) => item.data_source == 'tag',
    );

    return (
      <ContentButtonContainer>
        <h6>프로필 등록 캐릭터</h6>
        {profileSpeaker &&
          profileSpeaker.map((v, i) => (
            <button
              key={i}
              value={v.speaker}
              name={v.speaker}
              onClick={handleClickSideButton}
            >
              {v.speaker}
            </button>
          ))}

        <h6>네임태그 등록 캐릭터</h6>
        {tagSpeaker &&
          tagSpeaker.map((v, i) => (
            <button
              key={i}
              value={v.speaker}
              name={v.speaker}
              onClick={handleClickSideButton}
            >
              {v.speaker}
            </button>
          ))}
      </ContentButtonContainer>
    );
  }; // ? END divSpeakerSide

  // * 템플릿 버튼 사이드 영역
  const divTemplateButtons = () => {
    console.log(`divTemplateButtons`);
    if (!templateButtons) {
      return '';
    }

    const talkTemplates = templateButtons.filter(
      (item) => item.extra == 'talk',
    );
    const resourceTemplates = templateButtons.filter(
      (item) => item.extra == 'resource',
    );

    const screenTemplates = templateButtons.filter(
      (item) => item.extra == 'screen',
    );

    const selectionTemplates = templateButtons.filter(
      (item) => item.extra == 'selection',
    );
    const phoneTemplates = templateButtons.filter(
      (item) => item.extra == 'phone',
    );
    const etcTemplates = templateButtons.filter((item) => item.extra == 'etc');

    // screen, phone, selection, etc  등등

    return (
      <ContentButtonContainer>
        <h6>대화 템플릿</h6>
        {talkTemplates &&
          talkTemplates.map((v, i) => (
            <button
              key={i}
              value={v.code}
              name={v.code_name}
              onClick={handleClickSideButton}
            >
              {v.code_name}
            </button>
          ))}
        <h6>리소스 템플릿</h6>
        {resourceTemplates &&
          resourceTemplates.map((v, i) => (
            <button
              key={i}
              value={v.code}
              name={v.code_name}
              onClick={handleClickSideButton}
            >
              {v.code_name}
            </button>
          ))}
        <h6>앵글, 연출 템플릿</h6>
        {screenTemplates &&
          screenTemplates.map((v, i) => (
            <button
              key={i}
              value={v.code}
              name={v.code_name}
              onClick={handleClickSideButton}
            >
              {v.code_name}
            </button>
          ))}
        <h6>선택지 관련 템플릿</h6>
        {selectionTemplates &&
          selectionTemplates.map((v, i) => (
            <button
              key={i}
              value={v.code}
              name={v.code_name}
              onClick={handleClickSideButton}
            >
              {v.code_name}
            </button>
          ))}
        <h6>전화 관련 템플릿</h6>
        {phoneTemplates &&
          phoneTemplates.map((v, i) => (
            <button
              key={i}
              value={v.code}
              name={v.code_name}
              onClick={handleClickSideButton}
            >
              {v.code_name}
            </button>
          ))}
        <h6>기타 템플릿</h6>
        {etcTemplates &&
          etcTemplates.map((v, i) => (
            <button
              key={i}
              value={v.code}
              name={v.code_name}
              onClick={handleClickSideButton}
            >
              {v.code_name}
            </button>
          ))}
      </ContentButtonContainer>
    );
  };

  // 행 추가
  const insertRow = () => {
    jssRef.current.jspreadsheet[0].insertRow();
  };

  // * 불러온 엑셀 데이터를 그리드에 할당
  const setImportedExcelData = () => {
    console.log(`setImportedExcelData`);

    jssRef.current.jspreadsheet[0].setData(importedExcel);
  };

  // * 엑셀 다운로드 기능
  const handleExcelDownload = () => {
    console.log(`handleExcelDownload`);
    const ws = utils.json_to_sheet(jssRef.current.jspreadsheet[0].options.data);
    const wb = utils.book_new();
    // 컬럼명 배열에 답기
    let columnArray = [];
    jssRef.current.jspreadsheet[0].options.columns.map((v) =>
      columnArray.push(v.title),
    );
    // console.log(columnArray);
    // 컬럼을 한글로 바꾸자
    columnArray.forEach((v, i) => {
      const cellAdd = utils.encode_cell({ c: i, r: 0 });
      ws[cellAdd].v = v;
    });

    // 에피소드 id, 프로젝트 id 열 숨기기
    ws['!cols'] = [];
    ws['!cols'][3] = { wch: 60 };
    ws['!cols'][6] = { wch: 30 };
    ws['!cols'][17] = { hidden: true };
    ws['!cols'][18] = { hidden: true };
    ws['!cols'][19] = { hidden: true };
    ws['!cols'][20] = { hidden: true };
    ws['!cols'][21] = { hidden: true };
    ws['!cols'][22] = { hidden: true };

    // 현재 시간 출력
    const today = dayjs().format('MMDD_HHmmss');
    utils.book_append_sheet(wb, ws, 'SHEET JS');
    writeFile(wb, `${episodeTitle}_${today}.xlsx`);
  }; // ? END handleExcelDownload

  // * 서버 저장
  const handleSubmit = async () => {
    console.log(`handleSubmit`);

    setIsLoading(true);

    // 오브젝트들이 모인 array
    const submitData = jssRef.current.jspreadsheet[0].options.data; // 저장 데이터 처리
    let rowNum = 0;
    // 일부 number 타입에 대해서 null 및 기본값 처리 필요
    for (const scriptRow of submitData) {
      ++rowNum;

      if (!scriptRow.scene_id || Number.isNaN(scriptRow.scene_id))
        scriptRow.scene_id = null;

      if (!scriptRow.selection_group || Number.isNaN(scriptRow.selection_group))
        scriptRow.selection_group = 0;

      if (!scriptRow.selection_no || Number.isNaN(scriptRow.selection_no))
        scriptRow.selection_no = 0;

      if (!scriptRow.bubble_size || Number.isNaN(scriptRow.bubble_size))
        scriptRow.bubble_size = null;

      if (!scriptRow.bubble_pos || Number.isNaN(scriptRow.bubble_pos))
        scriptRow.bubble_pos = null;

      if (!scriptRow.autoplay_row || Number.isNaN(scriptRow.autoplay_row))
        scriptRow.autoplay_row = 0;

      // 치명적인 문제들은 여기서 걸러낸다.
      if (scriptRow.template == null || scriptRow.template == '') {
        handleMessage(
          message,
          'error',
          `템플릿이 입력되지 않은 행이 있습니다😰 [ ${rowNum}라인!! ]`,
        );

        setIsLoading(false);

        return;
      }
    }

    console.log(`submitData : `, submitData);

    const result = await scriptAPI.saveScript(project_id, episode_id, lang, {
      script: submitData,
    });

    if (result && result.length > 0) {
      jssRef.current.jspreadsheet[0].setData(result.script);
    }

    if (result && result.isSuccess) {
      handleMessage(message, 'success', '스크립트가 저장되었습니다.');
    }

    setIsLoading(false);

    // 스크립트 유효성 체크
    // validateScript();
  }; // ? END 서버 저장

  // * 스크립트 유효성 검사
  const validateScript = () => {
    const scriptData = jssRef.current.jspreadsheet[0].options.data;
    const validationResult = checkScriptValidation(scriptData);

    // 다시 그리드 색상 원상복구 처리
    for (let i = 0; i < jssRef.current.jspreadsheet[0].rows.length; i++) {
      const cell = jssRef.current.jspreadsheet[0].getCellFromCoords(0, i);

      if (i % 2 == 0)
        cell.parentNode.style.backgroundColor = theme.colors.script_default_row;
      else cell.parentNode.style.backgroundColor = theme.colors.script_even_row;
    }

    console.log(validationResult);

    if (validationResult && validationResult.length > 0) {
      // state 변경
      setValidationShow(true);
      setValidationData(validationResult);
    } else {
      setValidationShow(false);
    }

    // 색상 변경
    validationResult.forEach((item) => {
      const cell = jssRef.current.jspreadsheet[0].getCellFromCoords(
        0,
        item.rownum - 1,
      );
      cell.parentNode.style.backgroundColor =
        theme.colors.script_invalidate_row;
    });
  }; // ? END 유효성 검사

  // * 창 닫기
  const handleClose = () => {
    console.log(`handleClose`);
    window.close();
    // validateScript();
  };

  const convertUnescapeHTML = (str) => {
    if (!str) return '';

    return str
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'")
      .replace(/&#39;/g, "'");
  };

  // * useEffect
  useEffect(() => {
    console.log(`useEffect start`);

    // * jspredsheet 생성!!
    if (!jssRef.current.jspreadsheet) {
      jspreadsheet(jssRef.current, {
        allowExport: false,

        // html 특수문자를 일반 스트링으로 변환
        oncopy: (sheet, selectedCells, data, cut) => {
          console.log(`oncopy data : `, data);
          data = convertUnescapeHTML(data);
          return data;
        },
        // onbeforepaste: (sheet, data, x, y, props) => {
        //   console.log(`onbeforepaste `, data);
        // },

        onselection: (sheet, px, py, ux, uy, origin) => {
          console.log(`onselection ${px}/${py}/${ux}/${uy}/${origin}`);
          // selectedColRef.current = px;

          setSelectedColState(px);
          setSelectedRowState(py);
          // selectedCol = px;
          // selectedRow = py;

          // setSideWidth('0px');

          // 특정 컬럼의 경우 좌측 사이드 영역 활성화
          // 1 : 템플릿
          // 2 : 화자
          // 3 : 데이터
          // 6 : 캐릭터 모션
          // 7 : 이모티콘
          // 13 : 등장효과
          // 14 : 퇴장효과
          if (px === 1 || px === 2 || px === 6 || px === 7) {
            setRightSideWidth('300px');
            setLeftSideWidth('0px');
          } else if (px === 13 || px === 14) {
            setRightSideWidth('0px');
            setLeftSideWidth('300px');
          } else if (
            px === 3 &&
            jssRef.current.jspreadsheet[0].getValueFromCoords(1, py) === '배경'
          ) {
            setRightSideWidth('300px');
            setLeftSideWidth('0px');
          } else {
            setRightSideWidth('0px');
            setLeftSideWidth('0px');
          }

          // 색상 변경 처리 (이전의 prevCell 원복)
          if (prevCell) {
            prevCell.style.backgroundColor = prevCellBackColor;
          }

          // 지금 고른 cell 로 교체 , 배경 변경
          prevCell = sheet.getCellFromCoords(px, py);
          prevCell.style.backgroundColor = '#deedf2';
        }, // ? END onselection
        worksheets: [
          {
            tableOverflow: true,
            columns: sheetColumns,
            selectionCopy: true,
            // virtualizationX: false,
            virtualizationY: false,

            // column 관련
            allowManualInsertColumn: false,
            allowDeleteColumn: false,
            allowRenameColumn: false,
            columnDrag: false,
            columnSorting: false,
          },
        ],
      });
    }

    console.log(
      `jssRef.current.jspreadsheet[0] : `,
      jssRef.current.jspreadsheet[0],
    );
    jssRef.current.jspreadsheet[0].setViewport(
      1920,
      windowHeight.current - 120,
    );

    if (importedExcel) {
      // 여기 데이터가 있으면, 불러온 excel 데이터를 사용.
      setImportedExcelData();
    } else handleFetchData(true); // 서버 데이터 불러오기.

    // fetchDropDownData();
  }, [refresh, importedExcel]); // ? END useEffect (depends refresh, importedExcel)

  const onHandleKeyDown = (event) => {
    // console.log(`onHandleKeyDown : `, event.key);
    // console.log(`onHandleKeyDown : `, event.ctrlKey);

    if (event.ctrlKey && event.key == 's') {
      event.preventDefault();
      console.log(`Ctrl + s!`);
      handleSubmit();
    }
  };

  // * Render
  return (
    <>
      <Helmet>
        <title>{projectTitle}</title>
        <meta charSet='utf-8' />
        <meta name='description' content='에피소드 스크립트 에디터' />
      </Helmet>

      <ScriptLayout>
        <Header>
          <div className='title_wrap'>
            <h6>{episodeTitle}</h6>
          </div>
          <div className='horizon_blank'></div>
          <div className='button_wrap'>
            <RegisterButton onClick={insertRow}>
              {t('editorContents.header.addRow')}
            </RegisterButton>
            <ExcelImport setImportedExcel={setImportedExcel} />
            <RegisterButton onClick={handleExcelDownload}>
              {t('editorContents.header.downloadExcel')}
            </RegisterButton>
            <RegisterButton disabled={isLoading} onClick={handleSubmit}>
              {t('editorContents.header.saveToServer')}
            </RegisterButton>
            <RegisterButton onClick={handleClose}>
              {t('editorContents.header.close')}
            </RegisterButton>
          </div>
        </Header>
        <RightSideHelper sideWidth={sideRightWidth}>
          <div className='sideNav'>
            {/* 사이드 헬퍼 구역 */}
            {selectedColState === 1 && divTemplateButtons()}
            {selectedColState === 2 && divSpeakerSide()}
            {selectedColState === 3 &&
              jssRef.current.jspreadsheet[0].getValueFromCoords(
                1,
                selectedRowState,
              ) === '배경' &&
              divBackgroundImageSide()}
            {selectedColState === 6 && divMotionSide()}
            {selectedColState === 7 && divEmoticonSide()}
          </div>
        </RightSideHelper>
        <LeftSideHelper sideWidth={sideLeftWidth}>
          <div className='sideNav'>
            {/* 왼쪽 사이드 헬퍼 구역 */}
            {selectedColState === 13 && divInEffectSide()}
            {selectedColState === 14 && divOutEffectSide()}
          </div>
        </LeftSideHelper>
        {/* <ButtonColumnBox></ButtonColumnBox> */}
        <ScriptWrapper validationShow={false} validNum={20}>
          <div
            ref={jssRef}
            className='tableColor'
            tabIndex={-1}
            onKeyDown={onHandleKeyDown}
          />
          <input
            type='button'
            value='맨 위로'
            className='top_button'
            onClick={() => {
              jssRef.current.jspreadsheet[0].goto(0);

              // if (sideWidth == '100px') setSideWidth('0px');
              // else setSideWidth('100px');
            }}
          />
        </ScriptWrapper>
        {validationData && (
          <ValidationCard
            validationData={validationData}
            setValidationShow={setValidationShow}
            validationShow={validationShow}
          />
        )}
      </ScriptLayout>
    </>
  );
};

export default ScriptSheet;

const Header = styled.div`
  display: flex;
  width: 100%;
  height: 60px;
  align-items: center;
  /* justify-content: space-between; */
  justify-content: center;
  background-color: #f8f8ff;
  padding: 1rem 2rem;

  .horizon_blank {
    width: 400px;
  }

  .title_wrap {
    h6 {
      font-size: 1.2rem;
      font-weight: bold;
    }

    h3 {
      font-size: 1.6rem;
      font-weight: bold;
    }
  }

  .button_wrap {
    button {
      margin-left: 0.5rem;
      /* background-color: blue; */
    }
  }
`;

const ContentButtonContainer = styled.div`
  button {
    /* border: 1px solid blue; */
    margin-right: 6px;
    margin-bottom: 6px;
    border-radius: 2px;
    padding: 4px 8px;
    background-color: #8a8dba;
    color: #f8f8ff;
  }

  h6 {
    font-size: 1.2rem;
    font-weight: bold;
    padding: 8px 8px;
    color: #3062d4;
  }

  h4 {
    font-weight: bold;
    padding: 8px 8px;
    color: #8a8dba;
    font-style: italic;
  }
`;

// 스크립트가 들어가는 구역
const ScriptWrapper = styled.div`
  /* width: 1000px; */
  /* border: 1px solid red; */
  background-color: #fff;
  z-index: 100;
  /* overflow: hidden; */
  overflow: auto !important;
  text-align: center;

  .jss > thead > tr > th {
    text-wrap: initial;
  }

  /* .jss_overflow > tbody > tr > td {
      text-overflow: ellipsis;
    } */

  .jss tbody tr:nth-child(even) {
    background-color: ${theme.colors.script_even_row};
    /* font-weight: bold; */
  }

  .jss {
    td {
      font-size: 14px;
      font-family: 'AppleSDNeo';
    }

    th {
      font-size: 12px;
      font-weight: bold;
      /* font-family: 'AppleSDNeo'; */
    }

    .jss_number {
      text-align: center;
    }
  }

  .top_button {
    background-color: ${theme.colors.script_side_button};
    color: white;
    font-weight: bold;
    height: 24px;
    padding: 0;
  }
`;

const RightSideHelper = styled.div`
  .sideNav {
    height: 100%; /* 100% Full-height */
    width: ${(props) =>
      props.sideWidth}; /* 0 width - change this with JavaScript */
    position: fixed; /* Stay in place */
    z-index: 1; /* Stay on top */
    top: 0; /* Stay at the top */
    right: 0;
    background-color: #f8f8ff; /* Black*/
    overflow-x: hidden; /* Disable horizontal scroll */
    padding-top: 60px; /* Place content 60px from the top */
    padding-left: 4px;

    border: ${(props) => (props.sideWidth == '0px' ? 0 : 1)}px solid
      ${theme.colors.script_blue};
  }
`;
const LeftSideHelper = styled.div`
  .sideNav {
    height: 100%; /* 100% Full-height */
    width: ${(props) =>
      props.sideWidth}; /* 0 width - change this with JavaScript */
    position: fixed; /* Stay in place */
    z-index: 1; /* Stay on top */
    top: 0; /* Stay at the top */
    left: 0;
    background-color: #f8f8ff; /* Black*/
    overflow-x: hidden; /* Disable horizontal scroll */
    padding-top: 60px; /* Place content 60px from the top */
    padding-left: 4px;
    border: ${(props) => (props.sideWidth == '0px' ? 0 : 1)}px solid
      ${theme.colors.script_blue};
  }
`;
